export default __webpack_public_path__ + "static/media/moot-court-11.4add0341.webp";